import React, { useEffect, useState } from 'react';
import api from '../api';
import useAdminDialog from '../components/AdminDialog';
import { useAdminLanguage } from '../AdminLanguageContext';

const yuan = (cents) => (Number(cents || 0) / 100).toFixed(2);

export default function Orders() {
  const { copy } = useAdminLanguage();
  const ordersCopy = copy.orders;
  const STATUS_LABEL = {
    escrow: ordersCopy.status.escrow,
    completed: ordersCopy.status.completed,
    refunded: ordersCopy.status.refunded,
    disputed: ordersCopy.status.disputed,
  };
  const [orders, setOrders] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [keyword, setKeyword] = useState('');
  const [status, setStatus] = useState('');
  const [err, setErr] = useState('');
  const { confirmAction, requestText, dialog } = useAdminDialog();

  const load = () => {
    setLoading(true);
    api.get('/admin/finance/orders', { params: { keyword, status, limit: 50 } })
      .then(r => {
        setOrders(r.data.orders || []);
        setTotal(r.data.total || 0);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  const onForceRefund = async (o) => {
    const reason = await requestText({
      title: ordersCopy.forceRefund.promptTitle(o.order_no),
      message: ordersCopy.forceRefund.promptMessage,
      required: true,
      placeholder: ordersCopy.forceRefund.promptPlaceholder,
      variant: 'danger',
    });
    if (!reason || !reason.trim()) return;
    if (!await confirmAction({
      title: ordersCopy.forceRefund.confirmTitle,
      message: ordersCopy.forceRefund.confirmMessage(yuan(o.amount), o.buyer_name || ordersCopy.emptyValue),
      variant: 'danger'
    })) return;
    api.post(`/admin/finance/orders/${o.id}/force-refund`, { reason: reason.trim() })
      .then(() => load())
      .catch(e => setErr(e.response?.data?.error || e.message));
  };

  return (
    <div>
      {dialog}
      <div className="page-title">📋 {ordersCopy.title}</div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <div className="search-input" style={{ flex: 1 }}>
            <input
              placeholder={ordersCopy.searchPlaceholder}
              value={keyword}
              onChange={e => setKeyword(e.target.value)}
              onKeyUp={e => e.key === 'Enter' && load()}
            />
          </div>
          <select value={status} onChange={e => setStatus(e.target.value)}
            style={{ padding: '8px 12px', border: '1px solid #e5e7eb', borderRadius: 6 }}>
            <option value="">{ordersCopy.filters.allStatus}</option>
            <option value="escrow">{ordersCopy.status.escrow}</option>
            <option value="completed">{ordersCopy.status.completed}</option>
            <option value="refunded">{ordersCopy.status.refunded}</option>
            <option value="disputed">{ordersCopy.status.disputed}</option>
          </select>
          <button className="btn btn-outline" onClick={load}>🔍 {ordersCopy.search}</button>
          <span style={{ fontSize: 13, color: '#6b7280' }}>{ordersCopy.total(total)}</span>
        </div>
      </div>

      {err && <div style={{ background: '#fef2f2', color: '#991b1b', padding: 12, borderRadius: 6, marginBottom: 12 }}>{err}</div>}

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>{ordersCopy.columns.orderNo}</th><th>{ordersCopy.columns.task}</th><th>{ordersCopy.columns.buyer}</th><th>{ordersCopy.columns.seller}</th>
                <th>{ordersCopy.columns.amount}</th><th>{ordersCopy.columns.status}</th><th>{ordersCopy.columns.createdAt}</th><th>{ordersCopy.columns.actions}</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={8} style={{ textAlign: 'center', padding: 32, color: '#9ca3af' }}>{ordersCopy.loading}</td></tr>
              ) : orders.length === 0 ? (
                <tr><td colSpan={8} style={{ textAlign: 'center', padding: 32, color: '#9ca3af' }}>{ordersCopy.empty}</td></tr>
              ) : orders.map(o => (
                <tr key={o.id}>
                  <td style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 600 }}>{o.order_no}</td>
                  <td style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {o.task_title || `#${o.task_id}`}
                  </td>
                  <td>{o.buyer_name || ordersCopy.emptyValue}</td>
                  <td>{o.seller_name || ordersCopy.emptyValue}</td>
                  <td style={{ fontWeight: 700, color: '#1dbf73' }}>¥ {yuan(o.amount)}</td>
                  <td>{STATUS_LABEL[o.status] || o.status}</td>
                  <td style={{ fontSize: 12, color: '#6b7280' }}>
                    {o.created_at ? String(o.created_at).slice(0, 16) : ordersCopy.emptyValue}
                  </td>
                  <td>
                    {o.status === 'escrow' && (
                      <button className="btn btn-sm btn-outline" style={{ color: '#ef4444', borderColor: '#fecaca' }} onClick={() => onForceRefund(o)}>
                        {ordersCopy.actions.forceRefund}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
